import { render, staticRenderFns } from "./VuesticCheckbox.vue?vue&type=template&id=67cdad54&"
import script from "./VuesticCheckbox.vue?vue&type=script&lang=js&"
export * from "./VuesticCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VuesticCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticCheckbox.vue"
export default component.exports